/* Pagination replaces only cards and page controls, preserving the frame,
   collection heading, observers and completed entrance for this document. */
(() => {
  const root = document.getElementById('filterable');
  const list = root?.querySelector('.collection-list');
  const section = root?.closest('.shopify-section');
  if (!root || !list || !section) return;
  const sectionId = section.id.replace(/^shopify-section-/, '');
  const collectionPath = location.pathname;
  const cache = new Map();
  let currentURL = location.href;
  let controller;
  let generation = 0;
  const status = document.createElement('p');
  status.className = 'sr-only';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  root.append(status);

  function parse(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextList = doc.querySelector('#filterable .collection-list');
    const pagination = doc.querySelector('#filterable .ak-pagination-wrap');
    if (!nextList || !pagination) throw new Error('Collection results missing');
    return {nextList, pagination};
  }
  async function load(url, push) {
    controller?.abort();
    controller = new AbortController();
    const signal = controller.signal;
    const token = ++generation;
    root.setAttribute('aria-busy', 'true');
    status.textContent = 'Indlæser produkter…';
    try {
      let html = cache.get(url.href);
      if (!html) {
        const requestURL = new URL(url);
        requestURL.searchParams.set('section_id', sectionId);
        const response = await fetch(requestURL, {signal, credentials:'same-origin'});
        if (!response.ok) throw new Error('Collection request failed');
        html = await response.text();
        parse(html);
        cache.set(url.href, html);
        if (cache.size > 6) cache.delete(cache.keys().next().value);
      }
      const {nextList, pagination} = parse(html);
      // Prepare the first row while the current page remains visible.
      await Promise.all([...nextList.querySelectorAll('img')].slice(0, 12).map(img => {
        if (img.loading === 'lazy') img.loading = 'eager';
        return Promise.race([
          img.decode?.().catch(() => {}),
          new Promise(resolve => setTimeout(resolve, 1200))
        ]);
      }));
      if (signal.aborted || token !== generation) return;

      const wrap = list.closest('.ak-collection-grid-wrap');
      wrap?.classList.add('is-ak-collection-lines-drawn', 'is-ak-collection-animation-complete');
      wrap?.classList.remove('is-ak-collection-products-entering');
      list.removeAttribute('data-ak-format-rows');
      list.className = nextList.className;
      list.replaceChildren(...[...nextList.children].map(node => document.importNode(node, true)));
      root.querySelector('.ak-pagination-wrap').replaceWith(document.importNode(pagination, true));
      if (push) history.pushState({...history.state, akCollectionPage:true}, '', url);
      currentURL = url.href;

      // Existing mobile/desktop observers arrange the new cards on this frame.
      // Reset the scroll immediately; do not replay either entrance animation.
      const main = document.getElementById('MainContent');
      if (main) {
        const behavior = main.style.scrollBehavior;
        main.style.scrollBehavior = 'auto';
        main.scrollTop = 0;
        main.style.scrollBehavior = behavior;
      }
      window.scrollTo({top:0, left:0, behavior:'instant'});
      const heading = [...document.querySelectorAll('[data-ak-collection-editorial] h2')].find(element => element.getClientRects().length);
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({preventScroll:true});
      }
      status.textContent = `Side ${url.searchParams.get('page') || '1'} indlæst.`;
      root.dispatchEvent(new CustomEvent('ak:collection-page-changed', {bubbles:true}));
    } catch (error) {
      if (signal.aborted || token !== generation) return;
      if (!push) history.replaceState(history.state, '', currentURL);
      status.textContent = 'Produkterne kunne ikke indlæses. Prøv sideskiftet igen.';
    } finally {
      if (token === generation) root.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('#filterable .ak-pagination a');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin || url.pathname !== collectionPath) return;
    event.preventDefault();
    if (url.href !== currentURL || controller?.signal.aborted) load(url, true);
  });
  window.addEventListener('popstate', () => {
    if (location.pathname === collectionPath && (location.href !== currentURL || root.hasAttribute('aria-busy'))) load(new URL(location.href), false);
  });
})();
